import AdminHeader from '../AdminHeader';
import SubHeader from '../../SubHeader';
import SiteForm from './SiteForm'


function SiteAdd() {
  
  return (
    <>
      <AdminHeader/>
      <SubHeader nav={-1} display="Add Site"/> 
      <div className='add-site'>
        <SiteForm mode={"ADD"}/>
      </div>
    </>
  );
}

export default SiteAdd;
